module.exports = __webpack_public_path__ + "static/img/seat_value_pic3.3f708f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/seat_value_pic3.jpg
// module id = Lslh
// module chunks = 0